import { useEffect, useState } from "react";
import { Shell, Card } from "../components/Layout";
import { WeekGrid } from "../components/ScheduleGrid";
import { http, GROUPS, slotMatchesGroup } from "../lib/api";
import { Button } from "../components/ui/button";

export default function CentroSchedule() {
  const [slots, setSlots] = useState([]);
  const [group, setGroup] = useState("");

  useEffect(() => {
    http.get("/slots").then(({ data }) => setSlots(data));
  }, []);

  const shown = slots.filter((s) => slotMatchesGroup(s, group));

  return (
    <Shell accent="centro" title="Horario semanal del Centro de Estudios"
      subtitle="Se indica únicamente la franja, el grupo y su disponibilidad. Por confidencialidad no se muestran nombres de alumnos ni el número de plazas ocupadas."
      testid="centro-schedule-page">
      <Card className="mb-8">
        <p className="mb-4 text-lg font-medium">Filtrar por etapa</p>
        <div className="flex flex-wrap gap-3">
          <Button data-testid="filter-all-btn" variant={group === "" ? "default" : "outline"}
            className="h-12 text-base" onClick={() => setGroup("")}>Todas</Button>
          {GROUPS.map((g) => (
            <Button key={g.value} data-testid={`filter-${g.value}-btn`}
              variant={group === g.value ? "default" : "outline"} className="h-12 text-base"
              onClick={() => setGroup(g.value)}>
              {g.label}
            </Button>
          ))}
        </div>
      </Card>
      <WeekGrid slots={shown} />
      {shown.length === 0 && (
        <p data-testid="schedule-empty" className="rounded-2xl border border-border bg-white p-6 text-lg">
          No hay franjas disponibles para la etapa seleccionada.
        </p>
      )}
    </Shell>
  );
}
